import React, {
  useEffect,
  isValidElement,
  forwardRef,
  Children,
  useRef,
  cloneElement,
} from 'react';
import PropTypes from 'prop-types';
import { VariableSizeList } from 'react-window';
import calculateSize from 'calculate-size';
import OuterElement from './OuterElement';
import OuterElementContext from './OuterElementContext';

const LISTBOX_PADDING = 8; // px

function renderRow(props) {
  const { data, index, style } = props;

  return cloneElement(data[index], {
    style: {
      ...style,
      top: style.top + LISTBOX_PADDING,
      lineHeight: 1,
      overflowY: 'hidden',
      font: 'Arial',
      fontSize: '15px',
    },
  });
}
function useResetCache(data) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current != null) {
      ref.current.resetAfterIndex(0, true);
    }
  }, [data]);

  return ref;
}
const VirtualListboxComponent = forwardRef(function VirtualListboxComponent(
  props,
  ref
) {
  const { children, parentRef, getOptionSize, ...restProps } = props;
  const itemData = Children.toArray(children);
  const itemCount = itemData.length;
  const itemSize = 18;
  const getChildSize = (child) => {
    const {
      props: {
        children: {
          props: { children: values },
        },
      },
    } = child;

    const parentWidth = (parentRef.current?.clientWidth ?? 100) - 32 - 15; // includes padding offset and scroll bar offset

    try {
      if (getOptionSize) {
        return getOptionSize(child, parentWidth);
      } else {
        const size = calculateSize(values[1], {
          font: 'Arial',
          fontSize: '15px',
        });
        const overflowTimes = Math.ceil(size.width / parentWidth);

        return overflowTimes * itemSize + 16; // includes padding for each
      }
    } catch (error) {
      return 100;
    }
  };
  const getHeight = () => {
    if (itemCount > 8) {
      return 20 * itemSize;
    }

    return itemData.map(getChildSize).reduce((a, b) => a + b, 0);
  };
  const gridRef = useResetCache(itemCount);

  return (
    <div ref={ref}>
      <OuterElementContext.Provider value={restProps}>
        <VariableSizeList
          itemData={itemData}
          height={getHeight() + 2 * LISTBOX_PADDING}
          width="100%"
          ref={gridRef}
          outerElementType={OuterElement}
          innerElementType="ul"
          itemSize={(index) => getChildSize(itemData[index])}
          overscanCount={5}
          itemCount={itemCount}
        >
          {renderRow}
        </VariableSizeList>
      </OuterElementContext.Provider>
    </div>
  );
});

VirtualListboxComponent.propTypes = {
  children: PropTypes.node,
  parentRef: PropTypes.object,
  getOptionSize: PropTypes.func,
};

export default VirtualListboxComponent;
